<fisico-header></fisico-header>

<div class="main" class="containerVagas" style="background-color: #e5e5e5; margin-top: 15px;">
  <div class="row" style="background-color:#f4b357; ">
    <div class="col-md-4 pesquisa">
      <input [(ngModel)]="inputText"  type="text" class="form-control border-input inputFiltro" placeholder="Procure pelo nome da vaga" >
    </div>

    <div class="col-md-4 pesquisa">
      <input [(ngModel)]="inputTextCidade"  type="text" class="form-control border-input inputFiltro" placeholder="Procure pela cidade da vaga" >
    </div>
  </div>

  <div *ngIf="empresasFilt">
    <div class="center">
      <h4>Selecione uma empresa:</h4>
    </div>
    <div class="row">
      <div *ngFor="let emp of empresasFiltradas" class="col-md-3 vaga" (click)="filtrarEmp(emp)">
        <div class="cardEmp">
          <img class="logoEmpresa" [src]="emp.Caracteristica.Logo">
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="regiaoFilt">
    <div class="center">
      <h4>Selecione uma região:</h4>
    </div>
    <div class="row" style="margin-top: 20px">
      <div class="col-md-3" *ngFor="let estado of regioesFiltradas" (click)="filtrarEst(estado)">
        <div class="estado">
          <div class="btnEstado">
            <p style="padding-top: 20px">{{estado.estado}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

<!--  <div class="row" style="margin-bottom: 40px; margin-top: 40px">
    <div class="col-md-12">
      <input [(ngModel)]="filtro" (input)="filtrar()" type="text" class="form-control border-input"
      placeholder="Que tipo de vaga você procura?">
    </div>
  </div> -->

  <!-- <div class="col-md-1"></div> -->
  <div class="row">
    <div class="col-12 col-md-3">
      <div style="top: 0.5em">
        <div style="margin-top: 12%;" class="lds-ring" *ngIf="load">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

<!--      <div *ngIf="!load">
        <div *ngIf="!lista">
          <div *ngFor="let vaga of vagas" class="col-md-3 vaga" (click)="abrirVaga(vaga)" style="display: inline-block">
            <div class="cardNovo">
              <div class="cardHeader" style="text-align: center">
                <p class="txtName">{{vaga.Part.nome}}</p>
              </div>
              <div class="cardMid">
                <div>
                  <img class="logoEmpresaNovo" [src]="vaga.Empresa.Caracteristica.Logo">
                </div>
              </div>
              <div class="cardBot">
                <p class="dscLine" style="color: #000; font-size: 12px">Empresa:
                {{vaga.Card?.Empresa}}</p>
                <p class="dscLine" style="color: #000;font-size: 12px">Cidade:
                {{vaga.Card?.Localizacao}}</p>
                <p class="dscLine" style="color: #000;font-size: 12px">Resumo da vaga:</p>
                <p class="descVaga" style="color: #000">{{vaga.Part?.descricaoVaga}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>-->


      <div class="listaDiv" (onScroll)="scrolling($event)" *ngIf="exibeLista">
        <h4 style="margin-top: 0px; font-weight: 700; margin-bottom: 30px">Todas as vagas:</h4>

        <!-- VAGA -->
        <div *ngFor="let vaga of vagas | filter : 'title' : inputText | filter : 'city' : inputTextCidade " (onScroll)="scrolling($event)" (click)="abrirVaga(vaga)">
          <h5 style="font-weight: 700; margin-top: 0px; margin-bottom: 0px; cursor: pointer;">
            {{vaga.title}}
          </h5>
          <h6 style="font-weight: 700; margin-top: 5px; margin-bottom: 0px">
            Empresa: {{vaga.company}}
          </h6>
          <h6 style="font-weight: 700; margin-top: 5px; margin-bottom: 0px">
            Cidade: {{vaga.city}}
          </h6>
          <h6 style="font-weight: 700; margin-top: 5px; margin-bottom: 0px">
            Cargo: {{vaga.jobtype}}
          </h6>

          <p style="margin-top: 5px" class="descVaga2">
            {{vaga.description}}
          </p>

          <div class="borderVaga"></div>
        </div>
      </div>
    </div>

    <div *ngIf="!cliqueVagasMob" class="col-12 col-md-9 " style="padding-right: 0px">
      <div class="{{painelVaga}}">
        <div class="vagafixa">
          <div *ngFor="let vaga of vagasPainel" >
            <div *ngIf="!exibeLista" class="btnBackLista" (click)="backLista()">
              <img src="assets/img/left-arrow-branca.png" width="20px;">
            </div>
            <h5 style="font-weight: 700; font-size: 2em; margin-top: 0px; margin-bottom: 0px; ">
              {{vaga.title}}
            </h5>
            <p> {{vaga.company}} - {{vaga.city}}, {{vaga.state}} </p>
            <p>
              <a class="btnExte" href="{{vaga.url}}" style="width: 7.5em; color: #fff; margin-left: 0px; top: 15px; position: relative;" target="_blank">Candidate-se</a>
            </p>
            <br><br>
            <p>
              <b>Salário:</b> {{vaga.salary}} R$
            </p>
            <p style="margin-top: 5px; font-size: 1em;" class="descVaga3">
              {{vaga.description}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<fisico-footer></fisico-footer>